<template>
  <el-container class="container" ref="homePage">
    <el-header class="header" style="height: 70px;">
      <div class="logo_container">
        <img :src="logo" class="logo" />
      </div>
      <div class="top_menu">
        金石项目管理平台帮助文档
      </div>
			<div class="tianqi">
				<!-- <iframe width="100%" frameborder="0" scrolling="no" hspace="0" src="https://i.tianqi.com/?c=code&a=getcode&id=35&h=55&w=200"></iframe> -->
        <iframe width="210" scrolling="no" height="60" frameborder="0" allowtransparency="true" src="https://i.tianqi.com?c=code&id=12&color=%23FFFFFF&icon=1&num=1&site=12"></iframe>
			</div>
      <div class="userinfo">
        <img :src="this.userAvatar"/>
        <span class="userName">{{userName}}</span>
        <div class="loginfo">
          <ul>
            <!-- <li><router-link to="#"><img src="../assets/exit.png" style="width: 19px;">个人设置</router-link></li>
            <li><router-link to="#"><img src="../assets/exit.png" style="width: 16px;">项目管理</router-link></li>
            <li><router-link to="#"><img src="../assets/exit.png" style="width: 18px;">个人收藏</router-link></li> -->
            <li><span class="logout" @click="logout()"><img src="../assets/exit.png" style="width: 17px;">退出</span></li>
          </ul>
        </div>
      </div>
      
    </el-header>
    <el-container class="main">
      <el-aside class="menu-container" :class="collapsed?'menu-collapsed':'menu-expanded'">
        <!-- 根据路由表生成菜单 -->
          <el-menu :default-active="$router.path" class="el-menu-vertical-demo" @open="handleopen"  @close="handleclose" @select="handleselect"
           unique-opened router :collapse="collapsed" :default-openeds="opened">
            <template v-for="(item,index) in data" v-if="!item.hidden">
            	<el-submenu :index="item.path" v-if="!item.leaf" v-bind:key="index">
            		<template slot="title"><i :class="item.icon"></i>{{item.meta.title}}</template>
            		<el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden && (userName=='admin' || (userName!='admin' && adminMenuList.indexOf(child.meta.title)<0))"><i :class="child.icon"></i>{{child.meta.title}}</el-menu-item>
            	</el-submenu>
            	<el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path" v-bind:key="index"><i :class="item.icon"></i>{{item.children[0].meta.title}}</el-menu-item>
            </template>
          </el-menu>
        <!-- </div> -->
      </el-aside>
      <el-main class="content-container" ref="main">
        <!-- <div class="content-container"> -->
          <el-col :span="24" class="tabs">
            <Worktab></Worktab>
          </el-col>
          <el-col :span="24" class="nav">
            <!-- <strong class="title">{{$route.name}}</strong> -->
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-inner"><div style="float: left;">当前位置：</div>
              <el-breadcrumb-item v-for="item in $route.matched" :key="item.path" v-if="item.meta.title!=undefined">
                {{item.meta.title}}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <!-- <keep-alive :exclude="closingPage">
                <router-view></router-view>
              </keep-alive> -->
							<keep-alive v-if="$route.meta.keepAlive">
							  <router-view></router-view>
							</keep-alive>
							<router-view v-if="!$route.meta.keepAlive"></router-view>

            </transition>
          </el-col>
        <!-- </div> -->
      </el-main>
    </el-container>
  </el-container>


</template>

<script>
  import { mapMutations } from 'vuex';
  import Worktab from './Worktab'
  import * as util from '@/utils/util.js';

  let _ = require('lodash')

  export default {
    components: {
      Worktab: Worktab
    },
    data() {
      return {
        sysName: '金石项目管理平台帮助文档',
        logo: require('../assets/logo_white.png'),
        userName: '',
        userAvatar: require('../assets/avatar.jpg'),
        collapsed: false,
        clientHeight:'',
        data: [],
        load: true,
        searchValue: '',
        beforeUnloadTime: '',
        gapTime: '',
				opened: ['/manage'],
				adminMenuList: ['应用管理','用户管理']
      }
    },
    methods: {
      handleopen() {
        //console.log('open');
      },
      handleclose() {
        //console.log('close');
      },
      handleselect() {
        //console.log('select');
      },
      menuStyle(title){
        let returnStyle='';
        let classname=localStorage.getItem('classname') ? localStorage.getItem('classname') : 'common';
        if(classname=='common_large'){
          if(title.length>10){
            returnStyle='letter-spacing: -1px';
          }
        }
        return returnStyle;
      },
      logout() {
        this.$confirm('你确定要退出登录吗?', '提示', {
					cancelButtonClass: 'btn-custom-cancel',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
					
					this.$message({
            type: 'success',
            message: '退出成功!'
          });
					
					this.$store.commit('delToken');
					this.$store.commit('delRefreshToken');
					this.$store.commit('delUserInfo');
					sessionStorage.removeItem('user');
					this.$router.push({path: '/login',query: {redirect: this.$router.currentRoute.fullPath}});
					return;

          var url="/Handler/Login/Logout.ashx?mode=logout";
          this.$ajax.post(url).then((response)=>{
            //console.log(response.data);
            //console.log('logout',JSON.stringify(response.data));

          },function(err){
            console.log('logout error:',err);

            this.$store.commit('delToken');
            this.$store.commit('delRefreshToken');
            this.$store.commit('delUserInfo');
            sessionStorage.removeItem('user');
            this.$router.push({path: '/login'});
          });

          // let _this=this;
          // setTimeout(function(){
          //   _this.$store.commit('delToken');
          //   _this.$store.commit('delRefreshToken');
          //   sessionStorage.removeItem('user');
          //   _this.$router.push({path: '/login',query: {redirect: _this.$router.currentRoute.fullPath}});
          // },50);


        }).catch(() => {

        });

       },
       changeFixed(clientHeight){ //动态修改样式
          //console.log(clientHeight);
          //console.log(this.$refs.homePage.$el.style.height);
         this.$refs.main.$el.style.height = clientHeight-50-20+'px';
       },
       requestData()
       {

         var url="/Handler/Base/XiTongSheZhi/XiTongCaiDan.ashx";
         this.$ajax.post(url).then((response)=>{
           //console.log(response.data);
           //console.log(JSON.stringify(response.data));
           this.data=response.data;

           this.currentNode=this.data;
            this.load=true;
         },function(err){
           console.log(err);
           this.load=true;
         });
       },
       matchSubMenuHeight(event,index) {
         //console.log(index);
         let dom=document.getElementById('menu' + index);
         var submenu=dom.querySelector('.sub_menu');
         let main=document.querySelector('.el-main');
         let menu=document.querySelector('.menu');

         if(submenu)
         {
            //console.log('height:',submenu.offsetHeight,event.clientY,this.clientHeight,submenu.style.height);
            let bodyHeight = parseInt(this.clientHeight);
            let height=submenu.scrollHeight;
            let rowHeight=40; //一级菜单行高
            let minHeight=350;
            let top=40;
            let menuScrollTop=menu.scrollTop;
            let clientY=40 + index * rowHeight + 36 - menuScrollTop;
            //console.log(height,bodyHeight,clientY);
            //二级菜单位置
            if(clientY - height / 2<40)
            {
              top=40;
            }
            else
            {
              top=clientY - height / 2;
              if(top+height>bodyHeight)
              {
                top=bodyHeight - height;
                if(top>20)
                {
                  top=top-20;
                }
                else if(top<0)
                {
                  top=0;
                }
                //console.log('top:',top);
              }

            }

            //二级菜单高度
            if(height+70+top>bodyHeight)
            {
              height=bodyHeight - 70 - top;
              //console.log('1:',height);
            }

            if(height<minHeight)
            {
              height=minHeight;
              top=bodyHeight - height;

              if(top>20)
              {
                top=top-20;
              }
              else if(top<0)
              {
                top=0;
              }
            }

            //console.log('clientY:',clientY,'height:', height,'top:', top,'bodyHeight:',bodyHeight,'clientHeight:',this.clientHeight,'scroll',document.body.scrollTop,menuScrollTop);
            submenu.style.top=top + 'px';
            submenu.style.height=height + 'px';
         }
         else
         {
           //console.log('error');
         }
       },
       beforeunloadHandler(event){

         this.beforeUnloadTime=new Date().getTime();
         //console.log(event,window.event);
          //event = event || window.event;
          //event.preventDefault();
          //event.returnValue='close';
         //console.log('beforeunload:',this.beforeUnloadTime);
       },
       async unloadHandler(e){

         this.gapTime=new Date().getTime()-this.beforeUnloadTime;

         //console.log('unload:',this.gapTime);

         //判断是窗口关闭还是刷新
         if(this.gapTime<=5){
           //alert('close window.');
           const {data:res} = await this.$ajax.post("/Handler/Login/Logout.ashx?mode=close",{})

          //console.log(res);
           // var url="/Handler/Login/Logout.ashx?mode=close";
           // this.$ajax.post(url).then((response)=>{
           //   //console.log(response.data);
           //   //console.log('logout',JSON.stringify(response.data));

           // },function(err){
           //   console.log('logout error:',err);

           // });
         }
       },
       go(path){
         //console.log(path);
         this.$router.push({path: path});
         //this.$router.replace(path);
       }
    },
    mounted(){
			this.data=this.$router.options.routes;
			//this.data=global.antRouter;
			
			//console.log(this.data);
			
			this.load=true;
			
      this.userName=util.GetUserInfo().logname;
      //console.log(util.GetUserInfo())
      // 获取浏览器可视区域高度
      this.clientHeight =   `${document.documentElement.clientHeight}`
      setTimeout(()=>{
        //this.clientHeight = document.querySelector('.container').scrollHeight;

        this.$store.state.screenWidth = document.documentElement.clientWidth; //窗口宽度
        this.$store.state.screenHeight = this.clientHeight; //窗口高度

        let menu=document.querySelector('.menu');
				
				if(menu){
					menu.style.height=this.clientHeight-75 + 'px';
					//console.log('load',this.clientHeight);
				}
        
      },500)



      let that=this;
      this.$nextTick(() => {

        window.onresize=_.debounce(()=>{ //利用lodashJS防抖动，间隔50毫秒计算一次窗口高度、宽度
          that.clientHeight = `${document.documentElement.clientHeight}`;
          //that.clientHeight = document.querySelector('.container').scrollHeight;
          //console.log('resize',document.documentElement.clientHeight,document.documentElement.scrollHeight);
          that.$refs.main.$el.style.height = parseInt(that.clientHeight)-50-20 + 'px';

          that.$store.state.screenWidth = document.documentElement.clientWidth; //窗口宽度
          that.$store.state.screenHeight = that.clientHeight; //窗口高度

          let menu=document.querySelector('.menu');
					if(menu){
						menu.style.height=that.clientHeight-75 + 'px';
					}
          

        },50);

      });
      

    },
    destroyed() {
      
    },
    watch: {
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      clientHeight: function () {
        this.changeFixed(this.clientHeight);
        //console.log('watch:',this.clientHeight);
      }
    },
    computed: {
      closingPage () {
        return this.$store.state.closingPage
      }
    }
  }
</script>

<style lang="scss" scoped="scoped">
  .el-menu-vertical-demo:not(.el-menu--collapse) {
      width: 180px;
  		background-color: #fafafa;
    }
    .el-menu--collapse {
      overflow: hidden;
      width: 44px;
    }
    .container {
      position: absolute;
      top: 0px;
      bottom: 0px;
      width: 100%;
      height: 100%;
      border: 0px solid #F00;
      overflow-y: auto;
      .header {
        padding: 0;
        height: 70px;
        line-height: 70px;
        // background-color: #3389e0;
        background-color: #43b6c8;
        border-bottom: 0px solid #377a84;
        color: #FFFFFF;
  			font-size: 20px;
        text-align: left;
        .logo_container {
          float: left;
          border: 0px solid #FF0000;
          width: 179px;
          // background-color: #1271d0;
          background-color: #377a84;
					text-align: center;
          .logo {
            margin: 0 auto;
            width:65px;
  					border: 0px solid #FF0000;
            vertical-align: middle;
  
          }
        }
  			.title{
  				font-family: 微软雅黑;
  				float: left;
  				font-size: 24px;
  				padding-left: 20px;
  				border: 0px solid #F00;
  				letter-spacing: 5px;
  			}
        .top_menu {
          float: left;
          border: 0px solid #FF6600;
					padding-left: 20px;
          height: 70px;
          ul {
            margin: 0;
            padding: 0;
            display: inline-block;
  		  
            height: 70px;
            li {
              float: left;
              margin: 0;
              padding: 0;
              width: 144px;
              height: 70px;
              border: 0px solid #409EFF;
  			
              a {
                margin: 0;
                padding: 0;
                display: block;
                height: 70px;
                line-height: 70px;
                width: 100%;
                text-align: center;
                border: 0px solid #409EFF;
                font-size: 14px;
                color: #FFFFFF;
                img {
                  margin-right: 10px;
                  vertical-align: middle;
                }
              }
              a:hover {
                // background-color: #2568ad;
                background-color: #2598aa;
              }
              a:active {
                // background-color: #2568ad;
                background-color: #2598aa;
              }
              .active {
                // background-color: #2568ad;
                background-color: #2598aa;
              }
              &:active {
                // background-color: #2568ad;
                background-color: #2598aa;
              }
            }
  
  
          }
        }
        .search {
          float: right;
          margin-right: 30px;
          width: 240px;
          height: 70px;
          border: 0px solid #1976D3;
          .search_box {
            margin-top: 17px;
            padding: 0;
            padding-left: 15px;
            width: 240px;
            height: 36px;
            line-height: 36px;
            border: 1px solid rgba(#d3d3d3, 0.58);
            border-radius: 18px;
            background-color: rgba(#ffffff, 0.2);
            input {
              width: 180px;
              height: 34px;
              background-color: transparent;
              border: 0px solid #FFFFFF;
              font-size: 14px;
              color: #FFFFFF;
            }
            input:focus {
              border: 0px solid #FFFFFF;
              outline: 0px solid #AFECAB;
            }
            img {
              margin-bottom: 5px;
              vertical-align: middle;
            }
          }
        }
        .tianqi{
  				float: right;
          margin-top: 5px;
          width: 210px;
          height: 60px;
          overflow: hidden;
  			}
  			.userinfo {
          float: right;
          padding-left: 15px;
          text-align: left;
          border: 0px solid #FF0000;
          width: 148px;
          // background-color: #2568ad;
          background-color: #2598aa;
          margin-right: 15px;
          position: relative;
          font-size: 14px;
          img {
            width: 45px;
            height: 45px;
            margin-top: 10px;
            vertical-align: top;
            border-radius: 50%;
          }
          .userName {
            display: inline-block;
            vertical-align: top;
            margin-left: 10px;
          }
          .loginfo {
            width: 148px;
            display: none;
            padding: 10px 0px;
            // background-color: rgba(#2568ad,0.95);
            background-color: rgba(#2598aa,0.95);
            z-index: 9999;
          }
          &:hover {
            .loginfo {
              display: block;
              position: absolute;
              top: 70px;
              left: 0px;
              font-size: 14px;
              ul {
                display: block;
                width: 100%;
                li {
                  padding: 0px 0px;
                  width: 100%;
                  height: 40px;
                  line-height: 40px;
                  color: #FFFFFF;
                  text-align: left;
                  a {
                    padding-left: 20px;
                    display: block;
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    color: #FFFFFF;
                    img {
                      margin-right: 10px;
                      border-radius: 0;
                      height: 18px;
                      width: 18px;
                    }
                  }
                  a:hover {
                    // background-color: #1976D3;
                    background-color: #187381;
                  }
                  img {
                    margin-right: 10px;
                    border-radius: 0;
                    height: 18px;
                    width: 18px;
                  }
                }
              }
              .logout {
                padding-left: 20px;
                cursor: pointer;
                width: 100%;
                display: block;
              }
              .logout:hover {
                // background-color: #1976D3;
                background-color: #187381;
              }
            }
          }
        }
  
      }
      .main {
        padding-left: 0;
        // display: flex;
        position: relative;
        // top: 0px;
        // bottom: 0px;
        width: 100%;
        .menu-container {
          // flex: 0 0 200px;
          width: 120px;
          //background-color: #333c4b;
          background-color: #344772;
          background-color: #424256;
          text-align: left;
          overflow-x: hidden;
          overflow-y: auto;
          border-right: 1px solid #DDDDDD;
          .el-menu{
          	height: 100%;
            background-color: #333c4b;
  					background-color: #424256;
  					/deep/.el-submenu__title{
  						color: #E1E9EE;
  						font-size: 14px;
  						font-weight: bold;
  					}
  					/deep/ .el-submenu__title:hover{
  						background-color: #333c4b;
  						color: #FFFFFF
  					}
  					/deep/.el-submenu .el-menu-item{
  						background-color: #2d3745;
  						color: #E1E9EE;
  					}
  					/deep/.el-submenu .el-menu-item:hover{
  						background-color: #232c3b;
  						color: #FFFFFF;
  					}
          }
          .collapsed{
          	width: 50px;
          	.item{
          		position: relative;
          	}
          	.submenu{
          		position:absolute;
          		top:0px;
          		left:50px;
          		z-index:99999;
          		height:auto;
          		display:none;
          	}
  
          }
          .menu {
            //position: absolute;
            margin: 0;
            padding: 0;
            padding-top: 40px;
            display: inline-block;
            border: 0px solid #FFFFFF;
            color: #989ca4;
            width: 198px;
  		  
            //overflow-y: auto;
            height: 100%;
            li {
              width: 100%;
              height: 40px;
              text-align: center;
              cursor: pointer;
              // color: #e1e1e1;
              border: 0px solid #F3A405;
              .menu_icon {
                float: left;
                margin-left: 20px;
                border: 0px solid #FFFFFF;
                height: 40px;
                line-height: 40px;
                img {
                  margin-top: 0px;
                  vertical-align: middle;
                  height: 15px;
                }
              }
              .menu_title {
                float: left;
                margin-left: 10px;
                border: 0px solid #FFFFFF;
                height: 40px;
                line-height: 40px;
                text-align: left;
              }
              .sub_menu {
                display: none;
                padding: 15px 0px 20px 0px;
                min-height: 350px;
                max-height: 900px;
                overflow-y: auto;
                cursor: auto;
              }
              &:hover {
                color: #FFFFFF;
                //background: url(../assets/left_menu_bg.png) no-repeat #29303b 0px -16px;
                background: url(../assets/left_menu_bg.png) no-repeat #213250 0px -16px;
                .sub_menu {
                  display: block;
                  position: absolute;
                  top: 50px;
                  left: 119px;
                  z-index: 999999;
                  //background-color: rgba(#151a23,0.9);
                  background-color: rgba(#091940,0.9);
                  //background-color: #FF6600;
                  width: 450px;
                  //overflow-y: auto;
                  //cursor: auto;
                  border-radius: 0px 3px 3px 0px;
                  .sub_menu_title {
                    padding-left: 30px;
                    background: url(../assets/sub_menu_icon.png) no-repeat 20px center;
                    height: 40px;
                    line-height: 40px;
                    color: #FFFFFF;
                    font-size: 14px;
                    font-weight: bold;
                    text-align: left;
                  }
                  ul {
                    display: inline-block;
                    width: 100%;
                    border: 0px solid #1976D3;
                  }
                  li {
                    float: left;
                    display: block;
                    width: 220px;
                    height: 32px;
                    line-height: 32px;
                    background: none;
                    border: 0px solid #F0F9EB;
                    text-align: left;
                    color: #787e87;
                    font-size: 12px;
                    a {
                      padding: 0px 0px 0px 30px;
                      height: 32px;
                      line-height: 32px;
                      color: #888e97;
                    }
                    a:hover {
                      display: block;
                      width: 100%;
                      height: 32px;
                      line-height: 32px;
                      background-color: #364266;
                      color: #FFFFFF;
                    }
                  }
                }
                a {
                  display: block;
                  width: 100%;
                  height: 32px;
                  line-height: 32px;
                  padding: 0px 10px 0px 30px;
                  color: #787e87;
                  text-align: left;
                }
                a:hover {
                  display: block;
                  width: 100%;
                  height: 32px;
                  line-height: 32px;
                  background-color: #414651;
                  color: #FFFFFF;
                }
  
              }
            }
  
            .now {
              color: #FFFFFF;
              background: url(../assets/left_menu_bg.png) no-repeat #202632;
            }
          }
        }
        .menu-collapsed{
          flex:0 0 50px;
        	width: 50px;
        }
        .menu-expanded{
          flex:0 0 180px;
        	width: 180px;
        	padding-top: 0px;
        }
        .content-container {
          padding: 0;
          padding-top: 80px;
          flex: 1;
          height: 100%;
          overflow-y: auto;
          background-color: #F7F8F9;
          background-color: #FFFFFF;
          position: relative;
          .tabs {
            height: 43px;
            line-height: 43px;
            background-color: #e1e9ee;
            background-color: #f8f9fd;
            position: absolute;
            top: 0px;
            z-index: 999;
            width: 100%;
            font-size: 12px;
            border-bottom: 1px solid #d9dadc;
            border-bottom: 1px solid #f5f5f5;
          }
          .nav {
            height: 38px;
            line-height: 38px;
            background-color: #e1e9ee;
            background-color: #f5f5f5;
            border-top: 1px solid #d9dadc;
            position: absolute;
            // display: none;
            top: 40px;
            z-index: 99;
            width: 100%;
            font-size: 12px;
            .title {
            	width: 200px;
            	float: left;
            	color: #475669;
              text-align: left;
              padding: 0 20px;
  
            }
            .breadcrumb-inner {
            	//float: right;
              padding-left: 20px;
              line-height: 40px;
  
            }
          }
          .content-wrapper {
          	// background-color: #ECF1F5;
            // background-color: #F7F8F9;
            background-color: #FaFaFa;
            background-color: #FFFFFF;
            box-sizing: border-box;
            padding: 0px;
            display: inline-block;
            height: 100%;
            width: 100%;
  					overflow: auto;
            border: 0px solid #0044ff;
          }
        }
      }
    }
  input::-webkit-input-placeholder {
    color: #FFFFFF;
    font-size: 14px;
  }
  
  input:-moz-placeholder {
    color: #FFFFFF;
    font-size: 14px;
  }
  
  input::-moz-placeholder {
    color: #FFFFFF;
    font-size: 14px;
  }
  
  input:-ms-input-placeholder {
    color: #FFFFFF;
    font-size: 14px;
  }
  
</style>
